import posthog from 'posthog-js';
import type { EventProperties } from './types';

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const shouldSend = Boolean(posthogKey);
const shouldLog = process.env.REACT_APP_POSTHOG_DEBUG === 'true';

const trackEvent = (
    eventName: string,
    properties?: EventProperties,
): void => {
    if (shouldLog) {
        console.log('[Posthog]', eventName, properties);
    }

    if (shouldSend && posthog) {
        posthog.capture(eventName, properties);
    }
};

export default trackEvent;
